import { cloneDeep } from 'lodash';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ProductInterface } from '../data';
import { ProductProvider } from '../providers/product.provider';
import { Transaction } from '../transaction/transaction';
import { UseCase } from './common/use.case';

@Injectable()
export class GetProductsUseCase implements UseCase<Observable<Transaction<ProductInterface[]>>> {
    constructor(private productProvider: ProductProvider) {}

    bind(): Observable<Transaction<ProductInterface[]>> {
        return this.productProvider.find().pipe(
            map((transaction) =>
                transaction.map(
                    (products) => Transaction.success(cloneDeep(products)),
                    (throwable) => Transaction.error(throwable.message)
                )
            )
        );
    }
}
